import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { isAuthenticatedSelector, getCurrentUserAbilities } from 'app/models/auth/selectors';
import { isRestricted } from 'app/utils/auth';

const makeIsUserRestricted = createSelector(
  [
    isAuthenticatedSelector,
    getCurrentUserAbilities,
  ],
  (isAuthenticated, userAbilities) => (allow) =>
    isRestricted(allow, isAuthenticated, userAbilities),
);

/**
 * Creates and passes down a isUserRestricted method.
 */
const mapStateToProps = (state) => {
  const isUserRestricted = makeIsUserRestricted(state);
  return { isUserRestricted };
};

export const withRestrictions = connect(mapStateToProps);

export default withRestrictions;
